<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="">
    <s-header :name="'我的投诉'" :back="'/home'"></s-header>
    <!--    <van-tabs @click-tab="onChangeTab" :color="'#1baeae'" :title-active-color="'#1baeae'" class="order-tab" v-model:active="status">-->
    <!--      <van-tab title="全部" name=''></van-tab>-->
    <!--      <van-tab title="待付款" name="0"></van-tab>-->
    <!--      <van-tab title="待确认" name="1"></van-tab>-->
    <!--      <van-tab title="待发货" name="2"></van-tab>-->
    <!--      <van-tab title="已发货" name="3"></van-tab>-->
    <!--      <van-tab title="交易完成" name="4"></van-tab>-->
    <!--    </van-tabs>-->
    <div class="">
      <div class="">
        <!--      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="order-list-refresh">-->
        <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            @offset="10"
        >
          <div v-for="(item, index) in list" :key="index" class="">
            <div class="order-item-header">
              <!--              <van-cell v-for="(value, key) in item" :key="key" center title="单元格" :value="key" label="描述信息"/>-->

              <van-cell-group inset>
                <van-field label="事件" :model-value="item.title" readonly type="textarea"
                />
                <van-field label="时间" :model-value="item.time" readonly/>
                <van-field label="姓名" :model-value="item.name" readonly/>
                <van-field label="手机" :model-value="item.phone" readonly/>
                <van-field label="说明" :model-value="item.content" readonly type="textarea"/>

              </van-cell-group>


              <van-image v-for="(pic, picIndex) in item.pictureUrls" :key="picIndex"
                         width="100"
                         height="100"
                         :src="pic"
                         style="margin: 0 4px"
              />
              <van-divider/>
            </div>


            <!--            <van-card-->
            <!--              v-for="one in item.newBeeMallOrderItemVOS"-->
            <!--              :key="one.orderId"-->
            <!--              :num="one.goodsCount"-->
            <!--              :price="one.sellingPrice"-->
            <!--              desc="全场包邮"-->
            <!--              :title="one.goodsName"-->
            <!--              :thumb="$filters.prefix(one.goodsCoverImg)"-->
            <!--            />-->
          </div>
        </van-list>
        <div class="add-button">
          <van-button type="primary" round block @click="show=true">新增</van-button>
        </div>
      </div>
      <!--      </van-pull-refresh>-->

    </div>
    <van-dialog v-model:show="show" title="新增" show-cancel-button @confirm="onSubmit" :before-close="beforeClose">
      <van-form @submit="onSubmit" ref="form">
        <van-cell-group inset>
          <van-field
              v-model="title"
              name="title"
              label="标题"
              placeholder="标题"
              :rules="[{ required: true, message: '标题' }]"
              type="textarea"
          />

          <van-field
              v-model="name"
              name="name"
              label="姓名"
              placeholder="姓名"
              :rules="[{ required: true, message: '姓名' }]"
          />


          <van-field
              v-model="phone"
              name="phone"
              label="手机"
              placeholder="手机"
              :rules="[{ required: true, message: '手机' }]"
          />


          <van-field
              v-model="content"
              name="content"
              label="内容"
              placeholder="内容"
              :rules="[{ required: true, message: '内容' }]"
              type="textarea"
          />


        </van-cell-group>

      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import {reactive, ref, toRefs} from 'vue';
import sHeader from '@/components/SimpleHeader'
import {useRouter} from 'vue-router';
// import axios from "@/utils/axios";
import {getLocal, setLocal} from "@/common/js/utils";

export default {
  name: 'Order',
  components: {
    sHeader
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      status: '',
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      page: 1,
      totalPage: 0,
      show: false,
      name: '',
      phone: '',
      title: '',
      content: ''
    })

    const form = ref(null)

    const loadData = async () => {
      // const {data, data: {list}} = await axios.get('/points', {pageNumber: state.page, status: state.status})
      let complaint = JSON.parse(getLocal("complaint")) || [{
        title: "福保街道长者食堂疫情期间关闭后，至今没有再开放，请问何时会开放\n",
        "name": "Eric",
        "phone": 13223011233,
        "time": '2023-02-08',
        content: "福田区福保街道长者食堂（新新家园面点王）疫情期间关闭后，至今没有再开放长者服务，请问何时会开放？ 目前已经全面放开，希望可以尽快提供长者食堂服务。\n"
      },
        {
          title: "领取结婚证必须预约吗？\n",
          "name": "黄先生",
          "phone": 13223011234,
          "time": '2023-02-05',
          content: "请问在深圳市领取结婚证必须预约吗？我们打算2月14号情人节领取结婚证，但是今天才知道需要预约，但是已经没有号码了。如果没有预约，直接排队，民政局是否会帮我们办理结婚证？ 如果深圳市必须预约，请问揭阳市领取结婚证必须预约吗？"
        }];
      state.list = state.list.concat(complaint)
      state.totalPage = 10
      state.loading = false;
      if (state.page >= 0) state.finished = true
    }

    const onChangeTab = (name) => {
      // 这里 Tab 最好采用点击事件，@click，如果用 @change 事件，会默认进来执行一次。
      state.status = name.name
      onRefresh()
    }

    const goTo = (id) => {
      setLocal('complaint', JSON.stringify([]))
      router.push({path: '/order-detail', query: {id}})
    }

    const goBack = () => {
      router.go(-1)
    }

    const onSubmit = () => {

    };
    const onLoad = () => {
      if (!state.refreshing && state.page < state.totalPage) {
        console.log(state.page)
        console.log(state.totalPage)
        state.page = state.page + 1
      }
      if (state.refreshing) {
        state.list = [];
        state.refreshing = false;
      }
      loadData()
    }

    const onRefresh = () => {
      state.refreshing = true
      state.finished = false
      state.loading = true
      state.page = 1
      onLoad()
    }
    const beforeClose = (type) => {
      if (type === "cancel") {
        return true;
      }
      console.log(form.value);
      return form.value.validate().then(() => {
            debugger; // eslint-disable-line no-debugger
            const value = form.value.getValues()
            const today = new Date();
            value['time'] = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
            state.list.push(value)
            setLocal('complaint', JSON.stringify(state.list))
            console.log('校验成功');
            return true;
          }
      ).catch(() => {
            console.log('校验失败');
            return false;
          }
      )
    }

    return {
      ...toRefs(state),
      onChangeTab,
      goTo,
      goBack,
      onLoad,
      onRefresh,
      onSubmit,
      beforeClose,
      form
    }
  }
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';

.order-box {
  .order-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .fj();
    .wh(100%, 44px);
    line-height: 44px;
    padding: 0 10px;
    .boxSizing();
    color: #252525;
    background: #fff;
    border-bottom: 1px solid #dcdcdc;

    .order-name {
      font-size: 14px;
    }
  }

  .order-tab {
    position: fixed;
    left: 0;
    z-index: 1000;
    width: 100%;
    border-bottom: 1px solid #e9e9e9;
  }

  .skeleton {
    margin-top: 60px;
  }

  .content {
    height: calc(~"(100vh - 70px)");
    overflow: hidden;
    overflow-y: scroll;
    //margin-top: 34px;
  }

  .order-list-refresh {
    .van-card__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .van-pull-refresh__head {
      background: #f9f9f9;
    }

    .order-item-box {
      margin: 20px 10px;
      background-color: #fff;
      text-align: left;

      .order-item-header {
        padding: 10px 20px 0 20px;
        text-align: left;
        //display: flex;
        //justify-content: space-between;
      }

      .van-card {
        background-color: #fff;
        margin-top: 0;
      }
    }
  }
}

.add-button {

  padding: 20px
}



</style>
